import React, { useContext, useEffect, useState } from "react";
import login from "../../../assets/Images/login.png";
import logo from "../../../assets/Images/logo.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./login.css";
import toast from "react-hot-toast";
import { LoginUser } from "../../../services/auth/Auth";
import { UserContext } from "../../../UserContext";
import { FaEye, FaEyeSlash } from "react-icons/fa";

function Login() {
  const navigate = useNavigate();
  const { toggleLoader } = useContext(UserContext);
  const location = useLocation();
  const [showPassword, setShowPassword] = useState(true);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData);
    const { email, password } = data;
  
    if (!email || !password) {
      toast.error("All fields are required!");
      return;
    }
  
    try {
      toggleLoader(true);
      const response = await LoginUser(email, password);
      const { authtoken, user, wallet } = response;
  
      localStorage.setItem(
        "userData",
        JSON.stringify({ user, authtoken, wallet })
      );
  
      toast.success("Login successful!");
      const lastPath = localStorage.getItem('lastPath') || '/'; // Retrieve the last path or default to home
      localStorage.removeItem('lastPath'); // Clean up the last path from storage
      navigate(lastPath); // Redirect to the last visited page or home
    } catch (error) {
      console.error("Login failed:", error);
      toast.error(error.message);
    } finally {
      toggleLoader(false);
    }
  };
  

  useEffect(() => {
    localStorage.removeItem("userData");
  }, [location]);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="auth-page">
      <div className="auth-header">
        <Link to="/" className="auth-logo">
          <img src={logo} alt="CGTHomes Logo" />
        </Link>
      </div>

      <div className="auth-container">
        <div className="auth-left">
          <div className="auth-image-wrapper">
            <img src={login} alt="Login Illustration" className="auth-image" />
          </div>
        </div>
        <div className="auth-right">
          <div className="auth-form-container">
            <div className="auth-form-header">
              <h2 className="auth-title">Login to your account</h2>
              <p className="auth-subtitle">
                New to CGTHomes? <Link to={"/register"} className="auth-link">Register</Link>
              </p>
            </div>
            <form className="auth-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  name="email"
                  placeholder="Enter your Email Address"
                  className="form-control"
                  required
                />
              </div>

              <div className="form-group password-field">
                <label className="form-label">Password</label>
                <div className="password-input-wrapper">
                  <input
                    type={!showPassword ? "text" : "password"}
                    name="password"
                    placeholder="Enter your Password"
                    className="form-control"
                    required
                  />
                  <button type="button" className="password-toggle" onClick={togglePasswordVisibility}>
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
              </div>

              <button className="auth-btn auth-btn-primary" type="submit">
                Login
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
